import { useMemo } from 'react';
import { ProductTypeEnum } from '../../../../types';
import { IconName } from '../../../Icons';
import type { FilterableProperty } from '../types';
import { getProductTypeFilterOptionLabel, getProductTypeFilterOptions } from './productTypeFilterUtils';

/**
 * This hook creates the filter property definition for the ProductTypeEnum.
 */
export function useProductTypesFilter({ includePredictionMarkets = false } = {}) {
  return useMemo(
    () =>
      ({
        key: 'AssetTypes',
        label: 'Product',
        icon: IconName.CubeTransparent,
        control: 'multi-select',
        options: getProductTypeFilterOptions(Object.keys(ProductTypeEnum), includePredictionMarkets),
        getOptionLabel: getProductTypeFilterOptionLabel,
      }) as const satisfies FilterableProperty,
    [includePredictionMarkets]
  );
}
